module.exports = new __parcel__URL__("portfolio.68edeb1a.svg").toString();